function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#EEEEEE"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15.5,
  stroke: "black",
  strokeOpacity: 0.1
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 11.0263C12 13.2462 13.7947 15.0526 16 15.0526C18.2053 15.0526 20 13.2462 20 11.0263C20 8.80647 18.2053 7 16 7C13.7947 7 12 8.80647 12 11.0263ZM23.1111 24H24V23.1053C24 19.6525 21.208 16.8421 17.7778 16.8421H14.2222C10.7911 16.8421 8 19.6525 8 23.1053V24H23.1111Z",
  fill: "#CCCCCC"
});

var SvgUnknownUser = function SvgUnknownUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnknownUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unknown_user.5b689552.svg";
export { ForwardRef as ReactComponent };